export default __webpack_public_path__ + "static/img11-6a84c7fcd34fc28bd7ac9fb202cb8099.png";